<div>
    <ng-content select="app-page-header"></ng-content>
</div>
<ng-content></ng-content>
